import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import { Field, Form, Formik, useFormik } from "formik";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";

import config from "../../../../config/config";
import { toastError, toastSuccess, toastWarn } from "../../../../common/Toast";
import {
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER,
  AWS_IMAGE_FOLDER_CATEGORIES,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import Loader from "../../../../components/Loader/Loader";
import { uploadAWS } from "../../../../common/AWSHelper";
import Select from "react-select";
import DataTable from "react-data-table-component";
import { checkUserPermission } from "../../../../common/UserPermission";
import { Noimage } from "../../../../common/imagePath";
import { Label } from "@material-ui/icons";
import CommonMatrialReactTable from "../../../../components/Datatable/CommonMatrialReactTable";
import InventorySubModulesRecordsModal from "../../../../components/Modal/InventorySubModulesRecordsModal";
import { Box } from "@mui/material";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";
import MaterialTableTreeComponent from "../../../../components/Datatable/MaterialTableTreeComponent";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "manage-categories";
let PERMISSION_EDIT = "edit-categories";
let PERMISSION_DELETE = "delete-categories";

const Categories = (props) => {
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [valueAllChecked, setValueAllChecked] = useState();
  const [formValues, setFormValues] = useState({
    ID: 0,
    Name: "",
    Hidefromgrid: false,
    ParentID: 0,
    Color: "",
    Imagename: "",
    CategoryInfopopup: "",
  });

  console.log(formValues, "formValues");
  const [selectedParentCategory, setselectedParentCategory] = useState(0);
  const [selectBrand, setselectBrand] = useState([]);
  const [filterBrand, setfilterBrand] = useState([]);
  console.log(selectBrand, "selectBrand");
  const [Imagename, setImagename] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [ImageUrl, setImageUrl] = useState("");
  const [CategoryInfopopup, setCategoryInfopopup] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Imagename: false });
  const [data, setData] = useState([]);
  const [filterdata, setfilterdata] = useState([]);
  const [searchedText, setSearchedText] = useState("");
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(100);
  const [sortingId, setSortingId] = useState(4);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [selectedData, setSelectedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchtext, setSearchText] = useState("");
  const [checkedBox, setCheckedBox] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [previewImage, setPreviewImage] = useState("");
  const [parentrefquickbookid, setParentRefQuickBookId] = useState(0);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  console.log(previewImage, "previewImage123");
  const [showLoaderUploadImage, setShowLoaderUploadImage] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [searchItemName, setSearchItemName] = useState("");
  const [categoryId, setCategoryId] = useState(0);
  const [categoriesList, setCategoriesList] = useState([]);
  const [filtercategoriesList, setfilterCategoriesList] = useState([]);
  const [sorting, setSorting] = useState([{ id: "Name", desc: false }]);
  const [rowCount, setRowCount] = useState(0);

  const [rowSelectData, setRowSelectData] = useState([]);
  const [rowSelection, setRowSelection] = useState({});
  const [categoryName, setCategoryName] = useState("");
  const [moduleID, setModuleId] = useState(0);
  const [runApi, setRunApi] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [toggle, setToggle] = useState("%"); // Initial toggle state
  const [value, setValue] = useState("");

  const [firstDynamicAlies, setFirstDynamicAlies] = useState();
  const [secondDynamicAlies, setSecondDynamicAlies] = useState();
  const [thirdDynamicAlies, setThirdDynamicAlies] = useState();

  const [firstDynamicVisble, setFirstDynamicVisible] = useState(false);
  const [secondDynamicVisble, setSecondDynamicVisible] = useState(false);
  const [thirdDynamicVisble, setThirdDynamicVisible] = useState(false);

  const [dynamicSiteRespose, setDynamicSiteRespose] = useState([]);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmActionIsEcom, setconfirmActionIsEcom] = useState(null);

  const handleInputPromoChangeSign = (e) => {
    setValue(e.target.value); // Update input value
  };

  const handleToggleChange = (e) => {
    e.preventDefault();
    setToggle(toggle === "%" ? "$" : "%");
  };

  console.log(selectedCategory, "selectedCategory");

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      setCustomStartingDate(selectedDate);
    }
  };

  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      setCustomEndingDate(selectedDate);
    }
  };
  const handleSubmitPromo = (e) => {
    e.preventDefault();

    if (selectedCategory?.length === 0) {
      toastWarn("Please Select Category");
      return;
    }
    const PromoData = {
      selectedCategory: selectedCategory.map((el) => el.value).join(","),
      PromoPrice: value,
      Sign: toggle === "%" ? 2 : 1,
      Promostartdate: customStartingDate,
      Promoenddate: customEndingDate,
      itemIdsList: "",
      promotionType: 0,
    };

    setLoading(true);
    axios
      .post(`${config.categoriesBaseUrl}/categories/PromoUpsert`, PromoData, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          setIsPopupOpen(false);
          setValue("");
          setCustomStartingDate();
          setCustomEndingDate();
          setToggle("%");
          setLoading(false);
        } else {
          toastError("Something Went Wrong");
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error in registration:", error);
        setLoading(false);
      });
  };

  console.log(categoriesList, "categoriesList");

  // const [quickbookid,setQuickbookId]= useState(0)

  const validationSchema = Yup.object().shape({
    // Name: Yup.string().required("Category name is required"),
    Name: Yup.string().required("Category Name is required"),
  });

  console.log(checkedBox, "checkedBox");

  useEffect(() => {
    const result = Object.keys(rowSelection).map(Number);
    setRowSelectData(result);
  }, [rowSelection]);

  // Get all data
const handleListData = (
  pagenumber,
  columnIndex,
  filtertext,
  pagination,
  currentorder,
  categoryId
) => {
  setLoading(true);

  // ---------- CATEGORY API CALL ----------
  axios
  .get(
    `${config.categoriesBaseUrl}/categories?filtertext=${
      filtertext || ""
    }&CatID=${categoryId || ""}&from=0`,
    {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
    }
  )
  .then((res) => {
    const responseData = res.data.ResponseData || [];

    // ✅ STEP: Build hierarchical category tree
const buildCategoryTree = (flatData) => {
  const idMap = {};
  const rootItems = [];

  // Step 1: Map IDs and initialize children
  flatData.forEach((item) => {
    item.children = [];
    idMap[item.ID] = item;
  });

  // Step 2: Push into parent's children or root
  flatData.forEach((item) => {
    if (item.ParentId && idMap[item.ParentId]) {
      idMap[item.ParentId].children.push(item);
    } else {
      rootItems.push(item);
    }
  });

  // Step 3: Clean empty children
  const clean = (nodes) => {
    nodes.forEach((node) => {
      if (!node.children.length) {
        delete node.children;
      } else {
        clean(node.children);
        // Optionally sort children too
        node.children.sort((a, b) => a.Name.localeCompare(b.Name));
      }
    });
  };

  clean(rootItems);

  // ✅ Step 4: Sort rootItems A–Z by Name
  rootItems.sort((a, b) => a.Name.localeCompare(b.Name));

  return rootItems;
};


    const treeData = buildCategoryTree(responseData);
    console.log(treeData, "✅ treeData");

    // ✅ Set final data
    setData(treeData);

    // Optional: for your filter lists
    if (filtertext === "" && categoryId === 0) {
      setfilterCategoriesList(responseData);
      setfilterdata(responseData);
    }

    // ✅ Handle checkbox selection logic
    const updatedData = responseData.filter(
      (el) => el.IsShowEcommerceMenu === 1
    );
    const idArray = updatedData.map((el) => el.ID);
    setCheckedBox(idArray);

    setValueAllChecked(responseData.length === idArray.length);

    setLoading(false);
  })
  .catch((err) => {
    setLoading(false);
    console.error("❌ Error fetching category data", err);
  });


  // ---------- BRAND API CALL ----------
  axios
    .get(
      `${config.brandBaseUrl}/brands?filtertext=${
        filtertext == undefined ? "" : filtertext
      }&currentorder=${
        currentorder?.length > 0
          ? currentorder[0]?.desc === undefined
            ? "desc"
            : currentorder[0]?.desc === true
            ? "desc"
            : "asc"
          : "desc"
      }&ordercolumn=${columnIndex}&pagenumber=${
        pagination?.pageIndex + 1
      }&pagesize=${0}`,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      }
    )
    .then((res) => {
      if (filtertext === "") {
        setfilterBrand(res.data.ResponseData);
      }

      setRowCount(res.data.ResponseData[0]?.TotalRecord);

      const updatedData = res.data.ResponseData?.filter(
        (el) => el.IsShowEcommerceMenu === 1
      );
      const idArray = updatedData.map((el) => el.ID);
      setCheckedBox(idArray);

      if (res.data.ResponseData?.length === idArray?.length) {
        setValueAllChecked(true);
      } else {
        setValueAllChecked(false);
      }

      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);
    });
};

  useEffect(() => {
    handleListData(
      1,
      perPage,
      searchtext,
      sortingId,
      sortingDirection,
      categoryId
    );
  }, []);

  const handleUpdate = (pID) => {
    setLoading(true);
    axios
      .get(`${config.categoriesBaseUrl}/categories/findbyid?id=${pID}`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        const categoriesData = res.data.ResponseData[0];
        setParentRefQuickBookId(categoriesData.ParentRefQuickbookId);

        const data = {
          ID: categoriesData.ID,
          Name: categoriesData.Name,
          Hidefromgrid: categoriesData.Hidefromgrid === 1 ? true : false,
          ParentID: categoriesData.ParentId,
          Color: categoriesData.Color,
          Imagename: categoriesData.Imagename || "",
          CategoryInfopopup: categoriesData.CategoryInfopopup,
        };

        setFormValues(data);
        setImageUrl(categoriesData.Imagename);
        setselectedParentCategory(categoriesData.ParentId);
        setLoading(false);

        let arrays = {};
        let strnew = categoriesData?.BrandId.split(",") || [];

        for (let i = 0; i < strnew.length; i++) {
          arrays[strnew[i]] = strnew[i];
        }

        let resultbrand = filterBrand
          ?.map((item) => {
            if (arrays[item.ID] == item.ID) {
              return {
                label: item?.Name,
                value: item?.ID,
              };
            }
            return null;
          })
          .filter(Boolean);

        console.log(resultbrand, "44554");
        setselectBrand(resultbrand);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // Crete and Update Data
  const handleSubmit2 = async (event) => {
    setLoading(true);
    console.log(selectedImage, "selectedImage");
    if (selectedImage) {
      if (validation("Imagename", selectedImage)) {
        await uploadFile(selectedImage, "Imagename", event);
      }
    } else {
      console.log(event, "event");
      handleSubmit("", event);
    }
  };

  const Categoryobj = {};
  Categoryobj.importDataXML = selectBrand;
  const CategoryJsonString = JSON.stringify(Categoryobj);

  let BrandOption = [];
  const ItemBrand = filterBrand.map((u, i) => {
    BrandOption[i] = {
      label: u.Name,
      value: u.ID,
    };
  });

  const handleSubmit = async (imageurl, eventObject) => {
    // console.log("Submit2")

    console.log(selectedParentCategory, "selectedParentCategory");
    const data = {
      id: eventObject.ID,
      name: eventObject.Name,
      hidefromgrid: eventObject.Hidefromgrid,
      parentid:
        selectedParentCategory === undefined ? 0 : selectedParentCategory,
      imagename: uploadImageUrlArray.join(","),
      color: eventObject.Color,
      categoryinfopopup: eventObject.CategoryInfopopup,
      loginuserid: loginUserId,
      quickbookid: selectedParentCategory?.quickbookid,
      parentrefquickbookid: parentrefquickbookid,
    };

    console.log(data, "datacategory");

    axios
      .post(
        `${config.categoriesBaseUrl}/categories/upsert`,
        {
          id: eventObject.ID,
          name: eventObject.Name,
          hidefromgrid: eventObject.Hidefromgrid,
          parentid:
            selectedParentCategory === undefined ? 0 : selectedParentCategory,
          imagename:
            uploadImageUrlArray.join(",") == "" ||
            uploadImageUrlArray.join(",") == null
              ? ImageUrl
              : uploadImageUrlArray.join(","),
          color: eventObject.Color,
          categoryinfopopup: eventObject.CategoryInfopopup,
          loginuserid: loginUserId,
          quickbookid: selectedParentCategory?.quickbookid,
          parentrefquickbookid: parentrefquickbookid,
          xmlImportCategory: CategoryJsonString,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleListData();

          eventObject.Name = "";
          eventObject.ID = 0;
          setLoading(false);
          window.location.reload();
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);

          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });
  };

  // Delete Tag
  const handleDeletePopup = (pID) => {
    const deleteRequestParam = {
      id: pID,
      loginuserid: loginUserId,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    setDeleteModalOpen(true);
  };

  const handleManageDataPopup = () => {
    const clearData = {
      ID: 0,
      Name: "",
      Hidefromgrid: false,
      ParentID: 0,
      Color: "",
      Imagename: "",
      CategoryInfopopup: "",
    };
    setFormValues(clearData);
    setImageUrl("");
  };

  let ParentCategoryOption = [];
  const ItemKits = data.map((u, i) => {
    ParentCategoryOption[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickbookId,
      parentrefquickbookid: u.ParentRefQuickbookId,
    };
  });

  let ParentCategoryOption1 = [];
  const ItemKits1 = filterdata.map((u, i) => {
    ParentCategoryOption1[i] = {
      label: u.Name,
      value: u.ID,
      quickbookid: u.QuickbookId,
      parentrefquickbookid: u.ParentRefQuickbookId,
    };
  });

  let ParentCategoryOption2 = [];
  const ItemKits2 = filtercategoriesList.map((u, i) => {
    ParentCategoryOption2[i] = {
      label: u.Name,
      value: u.ID,
      // quickbookid: u.QuickbookId,
      // parentrefquickbookid: u.ParentRefQuickbookId,
    };
  });

  //new
  const _handleFileChange = (e) => {
    console.log(e, "imageUpload");

    const file = e.target.files[0];
    setSelectedImage(file);

    if (file) {
      // Display a preview of the selected image
      setPreviewImage(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onload = (event) => {
        setPreviewImage(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validation = (name, value) => {
    console.log(value, "value");
    switch (name) {
      case "Imagename":
        if (!value.name.match(/\.(jpg|jpeg|png|gif|webp|mp4)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  let uploadImageUrlArray = [];
  console.log(ImageUrl, "ImageUrl");
  const uploadFile = async (file, type, event) => {
    setShowLoaderUploadImage(true);
    setBtnLoader({ [type]: true });
    await uploadAWS(file, AWS_IMAGE_FOLDER_CATEGORIES, (data) => {
      if (data) {
        setImageUrl(data);
        uploadImageUrlArray.push(data);
        setShowLoaderUploadImage(false);
        handleSubmit(data, event);
      }
    });
  };
  /* END AWS FILE UPLOAD */

  const handleDateFilterConfirm = () => {
    setShowDateFilterModal(false);
    handleAllSwitchOnOff(valueAllChecked);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
    setValueAllChecked(!valueAllChecked);
  };

  const handleAllSwitchOnOff = (checked) => {
    // const { checked } = e.target;
    console.log(checked, "checkedBy Allcategory");

    if (checked == true) {
      let finalArray = [];
      data.map((el) => finalArray.push(el?.ID));
      setCheckedBox(finalArray);

      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 1,
        };
      });
      setData(updatedData);
      // setfilterdata(updatedData);
      checkFunction(finalArray);
    } else {
      setCheckedBox([]);
      const updatedData = data.map((el) => {
        return {
          ...el,
          IsShowEcommerceMenu: 0,
        };
      });
      setData(updatedData);
      // setfilterdata(updatedData);
      checkFunction([]);
    }
  };

  const handelShowPopup = (checked) => {
    console.log(checked, "checked");
    setValueAllChecked(checked);
    setShowDateFilterModal(true);
  };

  console.log(data, "data");

// Helper to get all descendant IDs of a category node

const handleSwitchOnOff = (e, row) => {
  const { checked } = e.target;
  const categoryId = row.original.ID;

  let updatedCheckedBox = [...checkedBox];

  if (checked) {
    // Add parent
    if (!updatedCheckedBox.includes(categoryId)) {
      updatedCheckedBox.push(categoryId);
    }
    // If parent → also add children
    if (row.original.children && row.original.children.length > 0) {
      const childIds = getAllChildIds(row.original);
      childIds.forEach(id => {
        if (!updatedCheckedBox.includes(id)) {
          updatedCheckedBox.push(id);
        }
      });
    }
  } else {
    // Remove ONLY the clicked item (child or parent), not affecting others
    updatedCheckedBox = updatedCheckedBox.filter(id => id !== categoryId);
    // If parent → also uncheck all children
    if (row.original.children && row.original.children.length > 0) {
      const childIds = getAllChildIds(row.original);
      updatedCheckedBox = updatedCheckedBox.filter(id => !childIds.includes(id));
    }
  }

  setCheckedBox(updatedCheckedBox);

  // Update data state so UI matches
  const updatedData = data.map(item => ({
    ...item,
    IsShowEcommerceMenu: updatedCheckedBox.includes(item.ID) ? 1 : 0
  }));
  setData(updatedData);

  checkFunction(updatedCheckedBox);
};

// Helper to get all descendants by ID
// const getAllChildIds = (items, parentId) => {
//   let ids = [];
//   items.forEach(item => {
//     if (item.ParentId === parentId) {
//       ids.push(item.ID);
//       ids = ids.concat(getAllChildIds(items, item.ID));
//     }
//   });
//   return ids;
// };

// const handleBrandUpsert = (CatID, from, isChecked) => {
//   // Get all children IDs if CatID is a parent
//   const allIds = [CatID, ...getAllChildIds(data, parseInt(CatID))];

//   const payload = {
//     CatID: allIds.join(","), // assuming backend supports comma-separated IDs
//     ColumnName: from,
//     Value: isChecked ? 1 : 0,
//   };

//   axios
//     .post(
//       `${config.categoriesBaseUrl}/categories/upsertCategoryDynamic`,
//       payload,
//       {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: token,
//         },
//       }
//     )
//     .then((res) => {
//       if (res.data.ResponseCode === "SUCCESS") {
//         console.log("Updated successfully");

//         setData((prevData) =>
//           prevData.map((item) =>
//             allIds.includes(item.ID)
//               ? { ...item, [from]: isChecked ? 1 : 0 }
//               : item
//           )
//         );

//         toastSuccess("Categories Upsert Successfully");
//       } else {
//         console.warn("Update failed");
//       }
//     })
//     .catch((err) => {
//       console.error("API Error:", err);
//     });
// };

// Recursively get all IDs from the category tree
const getAllIdsFromTree = (nodes) => {
  let ids = [];
  nodes.forEach(node => {
    ids.push(node.ID);
    if (node.children && node.children.length > 0) {
      ids = ids.concat(getAllIdsFromTree(node.children));
    }
  });
  return ids;
};


// Recursive: get all descendant IDs from a tree node
const getAllChildIds = (node) => {
  let ids = [];
  if (node.children && node.children.length > 0) {
    node.children.forEach(child => {
      ids.push(child.ID);
      ids = ids.concat(getAllChildIds(child));
    });
  }
  return ids;
};

const handleBrandUpsert = (CatID, from, isChecked) => {
  const findNodeById = (nodes, id) => {
    for (let node of nodes) {
      if (node.ID === id) return node;
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  const getAllChildIds = (node) => {
    let ids = [];
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        ids.push(child.ID);
        ids = ids.concat(getAllChildIds(child));
      });
    }
    return ids;
  };

  let idsToUpdate = [];

  if (typeof CatID === "string" && CatID.includes(",")) {
    // Bulk update (header case)
    idsToUpdate = CatID.split(",").map(id => parseInt(id));
  } else {
    // Row update
    const clickedNode = findNodeById(data, parseInt(CatID));
    idsToUpdate =
      clickedNode && clickedNode.children && clickedNode.children.length > 0
        ? [parseInt(CatID), ...getAllChildIds(clickedNode)]
        : [parseInt(CatID)];
  }

  const payload = {
    CatID: idsToUpdate.join(","),
    ColumnName: from,
    Value: isChecked ? 1 : 0,
  };

  axios
    .post(
      `${config.categoriesBaseUrl}/categories/upsertCategoryDynamic`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
    .then((res) => {
      if (res.data.ResponseCode === "SUCCESS") {
        const updateNodes = (nodes) => {
          return nodes.map(node => {
            if (idsToUpdate.includes(node.ID)) {
              node = { ...node, [from]: isChecked ? 1 : 0 };
            }
            if (node.children && node.children.length > 0) {
              node = { ...node, children: updateNodes(node.children) };
            }
            return node;
          });
        };

        setData(prevData => updateNodes(prevData));

        toastSuccess("Categories Upsert Successfully");
      }
    })
    .catch((err) => {
      console.error("API Error:", err);
    });
};



  // const handleCategoryIsEcomUpsert = (CatID, from, isChecked) => {
  //   const payload = {
  //     CatID: CatID,
  //     ColumnName: from,
  //     Value: isChecked ? 1 : 0,
  //     // LoginUserId: loginUserId,
  //   };

  //   axios
  //     .post(
  //       `${config.categoriesBaseUrl}/categories/assignecommercemenu`,
  //       payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         console.log("Updated successfully");
  //         setData((prevData) =>
  //           prevData.map((item) =>
  //             item.ID == CatID
  //               ? {
  //                   ...item,
  //                   [from]: isChecked ? 1 : 0, // make sure this matches the server's format
  //                 }
  //               : item
  //           )
  //         );
  //         toastSuccess("Categories Upsert SuccessFully");
  //       } else {
  //         // toastError("Update failed");
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("API Error:", err);
  //     });
  // };

  const handleCategoryIsEcomUpsert = (CatID, from, isChecked) => {
  let idsToUpdate = [];

  // Helpers
  const getAllChildIds = (node) => {
    let ids = [];
    if (node.children && node.children.length > 0) {
      node.children.forEach(child => {
        ids.push(child.ID);
        ids = ids.concat(getAllChildIds(child));
      });
    }
    return ids;
  };

  const findNodeById = (nodes, id) => {
    for (let node of nodes) {
      if (node.ID === id) return node;
      if (node.children) {
        const found = findNodeById(node.children, id);
        if (found) return found;
      }
    }
    return null;
  };

  const updateNodesByIds = (nodes, idsToUpdate, columnKey, value) => {
    return nodes.map(node => {
      if (idsToUpdate.includes(node.ID)) {
        node = { ...node, [columnKey]: value };
      }
      if (node.children && node.children.length > 0) {
        node = { ...node, children: updateNodesByIds(node.children, idsToUpdate, columnKey, value) };
      }
      return node;
    });
  };

  // Determine IDs to update
  if (typeof CatID === "string" && CatID.includes(",")) {
    // Bulk update (header click)
    idsToUpdate = CatID.split(",").map(id => parseInt(id));
  } else {
    // Single row click
    const clickedNode = findNodeById(data, parseInt(CatID));
    idsToUpdate = clickedNode?.children?.length
      ? [parseInt(CatID), ...getAllChildIds(clickedNode)]
      : [parseInt(CatID)];
  }

  const payload = {
    CatID: idsToUpdate.join(","),
    ColumnName: from,
    Value: isChecked ? 1 : 0,
  };

  axios
    .post(
      `${config.categoriesBaseUrl}/categories/assignecommercemenu`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
    .then((res) => {
      if (res.data.ResponseCode === "SUCCESS") {
        setData(prevData =>
          updateNodesByIds(prevData, idsToUpdate, from, isChecked ? 1 : 0)
        );
        toastSuccess("Categories Upsert Successfully");
      }
    })
    .catch((err) => {
      console.error("API Error:", err);
    });
};

  const generateDynamicColumns = (
    configData,
    data,
    setData,
    setConfirmAction,
    handleBrandUpsert,
    visibilityFlags // ✅ Pass visibility flags
  ) => {
    const { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble } =
      visibilityFlags;
    const parseBool = (val) => ["true", true, "1", 1].includes(val);
    const columns = [];

    // Add MainSite column
    const mainSiteEnabled = parseBool(
      configData.find((item) => item.AppConfigkey === "MainSiteEnable")
        ?.AppConfigvalue
    );

    if (mainSiteEnabled) {
      const mainSiteAlias =
        configData.find((item) => item.AppConfigkey === "MainSiteAlias")
          ?.AppConfigvalue || "Main Site";
      const columnKey = "MainSite";

      columns.push({
      header: (
  <div>
    <input
      className="form-check-input mr-1"
      type="checkbox"
      checked={data.every((item) => item[columnKey] == 1)}
      onClick={() => {
        const allIds = getAllIdsFromTree(data).join(","); // ✅ all levels
        const allChecked = data.every((item) => item[columnKey] == 1);
        setConfirmAction({
          allIds,
          allChecked,
          newValue: allChecked ? 0 : 1,
          columnKey,
        });
      }}
    />
    <label>{mainSiteAlias}</label>
  </div>
),
        accessorKey: columnKey,
        // Cell: ({ row }) => (
        //   <input
        //     className="form-check-input"
        //     type="checkbox"
        //     role="switch"
        //     checked={!!row.original[columnKey]}
        //     onChange={(e) => {
        //       const isChecked = e.target.checked;
        //       handleBrandUpsert(
        //         row.original.ID.toString(),
        //         columnKey,
        //         isChecked ? 1 : 0
        //       );
        //       setData((prevData) =>
        //         prevData.map((item) =>
        //           item.ID === row.original.ID
        //             ? { ...item, [columnKey]: isChecked ? 1 : 0 }
        //             : item
        //         )
        //       );
        //     }}
        //   />
        // ),
        Cell: ({ row }) => (
  <input
    className="form-check-input"
    type="checkbox"
    role="switch"
    checked={!!row.original[columnKey]}
    onChange={(e) => {
      const isChecked = e.target.checked;
      handleBrandUpsert(
        row.original.ID,
        columnKey,
        isChecked // pass boolean
      );
    }}
  />
),

      });
    }

    // Handle dynamic Multisite columns
    for (let i = 1; i <= 3; i++) {
      const alias = configData.find(
        (el) => el.AppConfigkey === `SiteAlias${i}`
      )?.AppConfigvalue;
      const enabled = parseBool(
        configData.find((el) => el.AppConfigkey === `SiteEnable${i}`)
          ?.AppConfigvalue
      );
      const isVisible =
        (i === 1 && firstDynamicVisble) ||
        (i === 2 && secondDynamicVisble) ||
        (i === 3 && thirdDynamicVisble);

      if (enabled && alias && isVisible) {
        const columnKey = `MultisiteEcommerce${i}`;

        columns.push({
          header: (
            <div>
              <input
                className="form-check-input mr-1"
                type="checkbox"
                checked={data.every((item) => item[columnKey] == 1)}
                onClick={() => {
                  const allIds = getAllIdsFromTree(data).join(",");
                  const allChecked = data.every((item) => item[columnKey] == 1);
                  setConfirmAction({
                    allIds,
                    allChecked,
                    newValue: allChecked ? 0 : 1,
                    columnKey,
                  });
                }}
              />
              <label>{alias}</label>
            </div>
          ),
          accessorKey: columnKey,
          Cell: ({ row }) => (
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={!!row.original[columnKey]}
              onChange={(e) => {
                const isChecked = e.target.checked;
                handleBrandUpsert(
                  row.original.ID.toString(),
                  columnKey,
                  isChecked ? 1 : 0
                );
                // setData((prevData) =>
                //   prevData.map((item) => {
                //     const pathIds = item.CategoryPathId?.split(",") || [];
                //     if (pathIds.includes(row.original.ID.toString())) {
                //       return {
                //         ...item,
                //         [columnKey]: isChecked ? 1 : 0,
                //       };
                //     }
                //     return item;
                //   })
                // );
              }}
            />
          ),
        });
      }
    }

    return columns;
  };

  const generateDynamicIsShowEcomMenuColumns = (
    configData,
    data,
    setData,
    setconfirmActionIsEcom,
    handleCategoryIsEcomUpsert,
    visibilityFlags // ✅ same flags
  ) => {
    const { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble } =
      visibilityFlags;
    const parseBool = (val) => ["true", true, "1", 1].includes(val);
    const columns = [];

    // MainSite
    const mainSiteEnabled = parseBool(
      configData.find((item) => item.AppConfigkey === "MainSiteEnable")
        ?.AppConfigvalue
    );

    if (mainSiteEnabled) {
      const mainSiteAlias =
        configData.find((item) => item.AppConfigkey === "MainSiteAlias")
          ?.AppConfigvalue || "Main Site";
      const columnKey = "IsShowEcommerceMenuMainSite";

      columns.push({
        header: (
          <div>
            <input
              className="form-check-input mr-1"
              type="checkbox"
              checked={data.every((item) => item[columnKey] == 1)}
              onClick={() => {
                const allIds = getAllIdsFromTree(data).join(",");
                const allChecked = data.every((item) => item[columnKey] == 1);
                setconfirmActionIsEcom({
                  allIds,
                  allChecked,
                  newValue: allChecked ? 0 : 1,
                  columnKey,
                });
              }}
            />
            <label>{mainSiteAlias} Menu</label>
          </div>
        ),
        accessorKey: columnKey,
        enableSorting: false,
        Cell: ({ row }) => (
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={!!row.original[columnKey]}
            onChange={(e) => {
              const isChecked = e.target.checked;
              handleCategoryIsEcomUpsert(
                row.original.ID.toString(),
                columnKey,
                isChecked ? 1 : 0
              );
              // setData((prevData) =>
              //   prevData.map((item) =>
              //     item.ID === row.original.ID
              //       ? { ...item, [columnKey]: isChecked ? 1 : 0 }
              //       : item
              //   )
              // );
            }}
          />
        ),
      });
    }

    // Multisite Menu columns
    for (let i = 1; i <= 3; i++) {
      const alias = configData.find(
        (el) => el.AppConfigkey === `SiteAlias${i}`
      )?.AppConfigvalue;
      const enabled = parseBool(
        configData.find((el) => el.AppConfigkey === `SiteEnable${i}`)
          ?.AppConfigvalue
      );
      const isVisible =
        (i === 1 && firstDynamicVisble) ||
        (i === 2 && secondDynamicVisble) ||
        (i === 3 && thirdDynamicVisble);

      if (enabled && alias && isVisible) {
        const columnKey = `IsShowEcommerceMenuMultisiteEcommerce${i}`;

        columns.push({
          header: (
            <div>
              <input
                className="form-check-input mr-1"
                type="checkbox"
                checked={data.every((item) => item[columnKey] == 1)}
                onClick={() => {
                  const allIds = getAllIdsFromTree(data).join(",");
                  const allChecked = data.every((item) => item[columnKey] == 1);
                  setconfirmActionIsEcom({
                    allIds,
                    allChecked,
                    newValue: allChecked ? 0 : 1,
                    columnKey,
                  });
                }}
              />
              <label>{alias} Menu</label>
            </div>
          ),
          accessorKey: columnKey,
          enableSorting: false,
          Cell: ({ row }) => (
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              checked={!!row.original[columnKey]}
              onChange={(e) => {
                const isChecked = e.target.checked;
                handleCategoryIsEcomUpsert(
                  row.original.ID.toString(),
                  columnKey,
                  isChecked ? 1 : 0
                );
                // setData((prevData) =>
                //   prevData.map((item) =>
                //     item.ID === row.original.ID
                //       ? { ...item, [columnKey]: isChecked ? 1 : 0 }
                //       : item
                //   )
                // );
              }}
            />
          ),
        });
      }
    }

    return columns;
  };

  // Dynamically generate columns for "IsShowEcommerceMenu" (menu visibility per site)
  const dynamicColumnsSite = useMemo(
    () =>
      generateDynamicColumns(
        dynamicSiteRespose,
        data,
        setData,
        setConfirmAction,
        handleBrandUpsert,
        { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble }
      ),
    [
      dynamicSiteRespose,
      data,
      firstDynamicVisble,
      secondDynamicVisble,
      thirdDynamicVisble,
    ]
  );

  const dynamicIsShowEcomMenuCols = useMemo(
    () =>
      generateDynamicIsShowEcomMenuColumns(
        dynamicSiteRespose,
        data,
        setData,
        setconfirmActionIsEcom,
        handleCategoryIsEcomUpsert,
        { firstDynamicVisble, secondDynamicVisble, thirdDynamicVisble }
      ),
    [
      dynamicSiteRespose,
      data,
      firstDynamicVisble,
      secondDynamicVisble,
      thirdDynamicVisble,
    ]
  );

  const staticColumns = useMemo(() => [
    // {
    //   header: "ID",
    //   accessorKey: "ID",
    // },
    {
      header: "Categories",
      accessorKey: "Name",
    },
    {
      header: "Image",
      accessorKey: "ImageUrl",
      // size: "20",
      Cell: ({ row }) => (
        <>
          {row.original.ImageUrl ? (
            <a target="_blank" href={row.original.ImageUrl}>
              <img
                src={row.original.ImageUrl ? row.original.ImageUrl : Noimage}
                style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
              />
            </a>
          ) : (
            <img
              src={row.original.ImageUrl ? row.original.ImageUrl : Noimage}
              style={{ maxWidth: "25px", maxHeight: "25px", margin: "2px" }}
            />
          )}
        </>
      ),
    },
    {
      header: "Category Count",
      accessorKey: "Count",
      // size: "20",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          }}
          onClick={() => {
            setRunApi(true);
            setModuleId(row.original.ID);
            setCategoryName(row.original.Name);
          }}
        >
          {row.original.Count}
        </Box>
      ),
    },

    // {
    //   header: (
    //     <>
    //       <input
    //         class="form-check-input mr-1"
    //         onChange={(event) => handelShowPopup(event.target.checked)}
    //         type="checkbox"
    //         role="switch"
    //         checked={valueAllChecked === true}
    //       />{" "}
    //       <label> Show On Menu</label>
    //     </>
    //   ),
    //   left: true,
    //   accessorKey: "IsShowEcommerceMenu",
    //   Cell: ({ row }) => (
    //     <>
    //       <input
    //         class="form-check-input"
    //         onChange={(e) => handleSwitchOnOff(e, row)}
    //         type="checkbox"
    //         role="switch"
    //         checked={row.original.IsShowEcommerceMenu}
    //       />
    //     </>
    //   ),
    // },
  ]);

  // Final memoized columns list
  const columns = useMemo(() => {
    return [
      ...dynamicColumnsSite,
      ...staticColumns,
      ...dynamicIsShowEcomMenuCols,
    ];
  }, [
    firstDynamicVisble,
    secondDynamicVisble,
    thirdDynamicVisble,
    firstDynamicAlies,
    secondDynamicAlies,
    thirdDynamicAlies,
    valueAllChecked,
    data,
    dynamicColumnsSite,
    staticColumns,
    dynamicIsShowEcomMenuCols,
  ]);

  const [columnOrder, setColumnOrder] = useState([
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
    "mrt-row-actions",
  ]);

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPage, e.target.value, sortingId, sortingDirection, "");
  };

  console.log(checkedBox.join(","), "checkedBox");

  const checkFunction = (checkedCategory) => {
    let categoriesList = {
      categoriesList: checkedCategory.join(","),
      LoginUserId: loginUserId,
    };

    axios
      .post(
        `${config.categoriesBaseUrl}/categories/assignecommercemenu`,
        categoriesList,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          // toastSuccess(SUCCESS_MESSAGE)
          console.log("SetDone");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError(ERROR_EXISTS);
        } else {
          // toastError(ERROR_MESSAGE);
        }
      });
  };

  const renderRowActions = ({ row }) => {
    // const { original } = row;
    return (
      <>
        <div class="btn-group-sm" role="group">
          {checkUserPermission(PERMISSION_EDIT) ? (
            <Link
              className="btn btn-primary"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#ManageDataModal"
              data-backdrop="static"
              data-keyboard="false"
              onClick={() => handleUpdate(row.original.ID)}
            >
              Edit
            </Link>
          ) : (
            ""
          )}
          {checkUserPermission(PERMISSION_DELETE) ? (
            <Link
              className="btn btn-sm btn-secondary confirm-text ml-2"
              to="#"
              title="Delete"
              data-bs-toggle="modal"
              data-bs-target="#DeleteConfirmationModal"
              onClick={() => handleDeletePopup(row.original.ID)}
            >
              Delete
            </Link>
          ) : (
            ""
          )}
        </div>
      </>
    );
  };

  const handleGetData = () => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=EnableMultiSiteModule`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;
        setDynamicSiteRespose(responseData);
        console.log(responseData, "responseData=>786");

        const isFirstSiteEnabled = ["true", true, "1", 1].includes(
          responseData.find((el) => el.AppConfigkey === "FirstSiteEnable")
            ?.AppConfigvalue
        );

        const isFirstSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "FirstSiteAlias"
        )?.AppConfigvalue;
        const isSecondSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "SecondSiteAlias"
        )?.AppConfigvalue;
        const isThirdSiteAlies = responseData.find(
          (el) => el.AppConfigkey === "ThirdSiteAlias"
        )?.AppConfigvalue;

        const isFirstSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable1"
        )?.AppConfigvalue;
        const isSecondSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable2"
        )?.AppConfigvalue;
        const isThirdSiteVisible = responseData.find(
          (el) => el.AppConfigkey === "SiteEnable3"
        )?.AppConfigvalue;

        setFirstDynamicVisible(
          ["true", "1", true, 1].includes(isFirstSiteVisible)
        );
        setSecondDynamicVisible(
          ["true", "1", true, 1].includes(isSecondSiteVisible)
        );
        setThirdDynamicVisible(
          ["true", "1", true, 1].includes(isThirdSiteVisible)
        );

        setFirstDynamicAlies(isFirstSiteAlies);
        setSecondDynamicAlies(isSecondSiteAlies);
        setThirdDynamicAlies(isThirdSiteAlies);

        console.log(isFirstSiteAlies, "isFirstSiteAlies responseData=>786");

        console.log(isFirstSiteEnabled, "check if first site is enabled");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />

      {confirmAction && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Increase this
          }}
        >
          <div
            style={{
              background: "white",
              padding: "40px",
              borderRadius: "5px",
              zIndex: 10000,
            }}
          >
            <p className="text-center">
              Are you sure you want to{" "}
              {confirmAction.allChecked ? "uncheck" : "check"} all Categories?
            </p>
            <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleBrandUpsert(
                    confirmAction.allIds,
                    confirmAction.columnKey,
                    confirmAction.newValue
                  );
                  setData((prevData) =>
                    prevData.map((item) => ({
                      ...item,
                      [confirmAction.columnKey]: confirmAction.newValue,
                    }))
                  );
                  setConfirmAction(null);
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setConfirmAction(null)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmActionIsEcom && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "40px",
              borderRadius: "5px",
              zIndex: 10000,
            }}
          >
            <p className="text-center">
              Are you sure you want to{" "}
              {confirmActionIsEcom.allChecked ? "uncheck" : "check"} all
              Categories?
            </p>
            <div className="d-flex align-items-center justify-content-center gap-2 mt-4">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleCategoryIsEcomUpsert(
                    confirmActionIsEcom.allIds,
                    confirmActionIsEcom.columnKey,
                    confirmActionIsEcom.newValue
                  );
                  setData((prevData) =>
                    prevData.map((item) => ({
                      ...item,
                      [confirmActionIsEcom.columnKey]:
                        confirmActionIsEcom.newValue,
                    }))
                  );
                  setconfirmActionIsEcom(null);
                }}
              >
                Yes
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => setconfirmActionIsEcom(null)}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="page-wrapper cardhead">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb" style={{ marginLeft: "11px" }}>
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Manage Categories</li>
              </ul>
            </div>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <div
              className="col-md-4"
              style={{ width: "auto", minWidth: "400px" }}
            >
              <Select
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                onChange={(e) => {
                  setCategoryId(e.value);
                  handleListData(
                    1,
                    perPage,
                    searchtext,
                    sortingId,
                    sortingDirection,
                    e.value
                  );
                }}
                options={ParentCategoryOption2}
                placeholder="Categorie"
                styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                id="Category"
                name="Category"
                className="custom-search-select"
                style={{ width: "100%" }}
              />
            </div>

            <div>
              {/* Button to open the popup */}
              <div className="col-md-0">
                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => setIsPopupOpen(true)}
                >
                  Apply Promo
                </button>
              </div>

              {/* Popup Modal */}
              {isPopupOpen && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999, // High z-index to ensure it is above everything
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "white",
                      padding: "20px",
                      borderRadius: "8px",
                      width: "400px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                      zIndex: 10000, // Ensure popup content is on top
                    }}
                  >
                    <h5 className="mb-4">Apply Promo</h5>
                    {/* Popup Content */}
                    <form>
                      <div className="form-group">
                        <label>Promo Price</label>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <input
                            type="number"
                            className="form-control"
                            value={value}
                            onChange={handleInputPromoChangeSign}
                            placeholder={`Enter value (${toggle})`}
                            style={{ flex: 1, borderRadius: "0px" }}
                          />
                          <button
                            onClick={handleToggleChange}
                            className="category-percentage-button"
                          >
                            {toggle}
                          </button>
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Category</label>
                        <div
                          className="col-md-4"
                          style={{ width: "auto", minWidth: "300px" }}
                        >
                          <Select
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={true}
                            hideSelectedOptions={true}
                            isClearable={true}
                            isMulti={true}
                            onChange={setSelectedCategory}
                            options={ParentCategoryOption2}
                            placeholder="Categorie"
                            styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            id="Category"
                            name="Category"
                            className="custom-search-select"
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>
                      <div className="d-flex gap-2">
                        <div className="form-group">
                          <label>Start Date</label>
                          <CommonDatePicker
                            FinalDate={customStartingDate}
                            handleDateChange={handleChangeCustomStartingDate}
                          />
                        </div>
                        <div className="form-group">
                          <label>End Date</label>
                          <CommonDatePicker
                            FinalDate={customEndingDate}
                            handleDateChange={handleChangeCustomEndingDate}
                          />
                        </div>
                      </div>

                      <div className="d-flex justify-content-between">
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setIsPopupOpen(false)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handleSubmitPromo}
                        >
                          Apply
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-4">
              {rowSelectData?.length > 0 && (
                <button
                  className="btn btn-dark btn-sm mt-4"
                  onClick={() => handleDeletePopup(rowSelectData.join(","))}
                >
                  Delete Selected
                </button>
              )}
            </div>
            <div className="page-btn">
              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#ManageDataModal"
                  data-backdrop="static"
                  data-keyboard="false"
                  // className="btn btn-added"
                  className="btn btn-primary btn-sm pull-right"
                  onClick={() => handleManageDataPopup()}
                >
                  <i className="fa fa-plus me-2 lg"></i>Add Category
                </Link>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: "0px 20px 0 20px" }}>
              <div className="card-body pb-0">
                <div className="table-responsive">
                  <MaterialTableTreeComponent
                    columns={columns}
                    data={data}
                    hodiExport={false}
                    enableRowSelection={true}
                    enableRowActions={true}
                    renderRowActions={renderRowActions}
                    isRowSelectionManual={true}
                    setRowSelectData={setRowSelection}
                    setColumnOrder={setColumnOrder}
                    state={{
                      columnOrder,
                      rowSelection,
                    }}
                    
                    columnsToExport={[
                      "ID",
                      "Name",
                      "ParentId",
                      "Imagename",
                      "CreatedDate",
                      "Count",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Upset Model  */}
      <div
        className="modal fade"
        id="ManageDataModal"
        tabIndex={-1}
        aria-labelledby="upset"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-lg modal-dialog-centered"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="p-lg">Manage Categories</h6>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {" "}
                <span aria-hidden="true">×</span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <Formik
                {...props}
                initialValues={formValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit2}
                enableReinitialize
              >
                {({ values, errors, touched, handleChange, handleBlur }) => (
                  <Form>
                    <div className="row">
                      <div className="col-12">
                        <Field
                          type="hidden"
                          className="form-control"
                          id="ID"
                          name="ID"
                          value={values.ID}
                        />
                        <div className="row mb-2">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Parent Category
                          </label>
                          <div className="col-md-9">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              onChange={(el) =>
                                setselectedParentCategory(el.value)
                              }
                              options={ParentCategoryOption1}
                              placeholder="Select Parent Category"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              value={ParentCategoryOption1.find(
                                (el) => el.value == selectedParentCategory
                              )}
                              id="ParentID"
                              name="ParentID"
                              className="custom-search-select"
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Name<span className="text-danger">*</span>
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="text"
                              name="Name"
                              className={` form-control form-control-sm ${
                                errors.Name ? "is-invalid" : ""
                              }`}
                              placeholder="Enter Category Name"
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                            <div className="invalid-feedback">
                              {touched.Name && errors.Name ? errors.Name : ""}
                            </div>
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Color
                          </label>
                          <div className="col-md-9">
                            <Field
                              type="color"
                              name="Color"
                              className={`form-control form-control-sm form-control-color w-1`}
                              value={values.Color}
                              onBlur={handleBlur}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="row mb-3">
                          <label className="col-form-label col-md-3 col-form-label p-lg-medium">
                            Category Image
                          </label>
                          <div className="col-md-9">
                            <input
                              type="file"
                              onChange={(e) => _handleFileChange(e)}
                              name="Imagename"
                              className="form-control form-control-sm"
                            />
                          </div>
                        </div>

                        {(previewImage || ImageUrl) && (
                          <div className="row mb-3">
                            <div className="col-md-3"></div>
                            <div className="col-md-9">
                              <img
                                src={previewImage || ImageUrl}
                                alt="Category Image Preview"
                                className="ImagePreviewSize"
                              />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="col-lg-12 justify-content-right align-center">
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary btn-md me-1"
                        >
                          Submit
                        </button>
                        <Link
                          to="#"
                          className="btn btn-sm btn-dark btn-md me-1"
                          data-bs-dismiss="modal"
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.categoriesBaseUrl}/categories/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      {/* select all category popup */}
      <div
        className={`modal ${showDateFilterModal ? "d-block" : ""} `}
        style={{ background: "rgba(0,0,0, 0.4)" }}
        tabIndex="-1"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ justifyContent: "center" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="card-title">Confirmation</h5>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleDateFilterCancel()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <h6 className="col-form-label p-lg-medium">
                    Do you want to set at All ?
                  </h6>
                </div>
              </div>
            </div>

            <div className="modal-footer justify-content-center">
              {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}

              <button
                type="button"
                className="btn btn-primary"
                onClick={() => handleDateFilterConfirm()}
              >
                yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleDateFilterCancel}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <InventorySubModulesRecordsModal
        Module="Category"
        runApi={runApi}
        closepopup={() => {
          setRunApi(false);
          setModuleId(0);
          handleListData();
        }}
        ModuleId={moduleID}
        Name={categoryName}
        columnsToExport={[
          "ID",
          "Item",
          "Name",
          "ImageName",
          "CreatedDate",
          "ItemId",
          "ItemVariationId",
          "CategoryID",
          "Category",
        ]}
      />
    </>
  );
};

export default Categories;
